module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_09_american-village-91b87442153123e37da37c6bb90dc8a5.jpg";